/**
 * Routes that mount DuckDB WASM and run Parquet-backed queries.
 * Keep in sync with ConditionalDuckDBShell in App.tsx.
 */
export const DATA_ENGINE_PATHS = new Set(['/kommun', '/skola', '/dashboard']);

export function isEnginePath(pathname: string): boolean {
  return DATA_ENGINE_PATHS.has(pathname);
}
